import {Locale} from '@hebcal/hdate';
import poData from './es.po.js';
Locale.addLocale('es', poData);
